import React from 'react'
import { Link, useHistory } from 'react-router-dom'

import MetaTags from 'components/meta/MetaTags'
import ScrollTop from 'components/utils/ScrollTop'
import Container from 'components/layout/Container'
import SignupForm from './SignupForm'
import { Header, NavItem } from './styles'

const Signup = () => {
  const history = useHistory()

  const handleConfirmEmail = () => {
    history.push('/confirm-email')
  }

  return (
    <>
      <ScrollTop />
      <MetaTags title="Sign up" />
      <Container width={620} paddingY={40}>
        <Header>
          <ul>
            <NavItem>
              <Link to="/login" className="qa-login-link">
                Login
              </Link>
            </NavItem>
            <NavItem active>
              <Link to="/signup" className="qa-sign-up-link">
                Sign up
              </Link>
            </NavItem>
          </ul>
        </Header>
        <SignupForm onConfirmEmail={handleConfirmEmail} serverSide />
      </Container>
    </>
  )
}

export default Signup
